import { useGetCards } from './useGetCards'
import { useTileFilterSelections } from '../../../hooks/useTileFilterSelections'
import { CardsContent } from './CardsContent'

export const CardsComponent = ({ id }: { id: string }) => {
  const { data } = useGetCards(id, [])
  const { tileFilterSelections, filterChangeHandler } = useTileFilterSelections(data.filters)

  // Refetch with filters applied
  const dataWithFilters = useGetCards(id, tileFilterSelections).data

  return (
    <CardsContent
      filterChangeHandler={filterChangeHandler}
      tileFilterSchema={dataWithFilters.filters}
      uiSchema={dataWithFilters.uiSchema}
      dataSchema={dataWithFilters.dataSchema}
    />
  )
}

export function CardsComponentLoading() {
  return 'Loading...'
  // const lines = Array.from({ length: 10 }, (_, i) => i)
  // return (
  //   <div className="flex w-full flex-col gap-y-4">
  //     {lines.map((line) => (
  //       <Skeleton key={line} className="h-8 max-w-2xl" />
  //     ))}
  //   </div>
  // )
}
